/**
 * Forum API helper — uses the Nuts member's JWT token.
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const headers = (token) => ({ Authorization: `Bearer ${token}` });

export const forumApi = {
  listRooms: (token) =>
    axios.get(`${API_URL}/api/forum/rooms`, { headers: headers(token) }).then((r) => r.data),

  listThreads: (token, roomSlug) =>
    axios.get(`${API_URL}/api/forum/rooms/${roomSlug}/threads`, { headers: headers(token) }).then((r) => r.data),

  createThread: (token, roomSlug, payload) =>
    axios.post(`${API_URL}/api/forum/rooms/${roomSlug}/threads`, payload, { headers: headers(token) }).then((r) => r.data),

  getThread: (token, threadId) =>
    axios.get(`${API_URL}/api/forum/threads/${threadId}`, { headers: headers(token) }).then((r) => r.data),

  addComment: (token, threadId, payload) =>
    axios.post(`${API_URL}/api/forum/threads/${threadId}/comments`, payload, { headers: headers(token) }).then((r) => r.data),

  editComment: (token, commentId, payload) =>
    axios.patch(`${API_URL}/api/forum/comments/${commentId}`, payload, { headers: headers(token) }).then((r) => r.data),

  deleteComment: (token, commentId) =>
    axios.delete(`${API_URL}/api/forum/comments/${commentId}`, { headers: headers(token) }).then((r) => r.data),

  deleteThread: (token, threadId) =>
    axios.delete(`${API_URL}/api/forum/threads/${threadId}`, { headers: headers(token) }).then((r) => r.data),

  unread: (token) =>
    axios.get(`${API_URL}/api/forum/unread`, { headers: headers(token) }).then((r) => r.data),

  markSeen: (token) =>
    axios.post(`${API_URL}/api/forum/mark-seen`, {}, { headers: headers(token) }).then((r) => r.data),
};
